require('./globalPositionExpensesFilterSettings.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    GP_EXPENSES_FILTER_TYPE_ALL,
    GP_EXPENSES_FILTER_TYPE_ACCOUNTS,
    GP_EXPENSES_FILTER_TYPE_CARDS,
    GP_EXPENSES_FILTER_COMPARE_NONE,
    GP_EXPENSES_FILTER_COMPARE_PREVIOUS,
    GP_EXPENSES_FILTER_TYPE_ACCOUNT_ALL,
    GP_EXPENSES_FILTER_TYPE_ACCOUNT_CUSTOM
} = require('constants/index');

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');


// constants
const { ENABLED_CREDIT_CARD_FILTER } = require('constants/flagBasedFeatures');

class globalPositionExpensesFilterSettings extends React.Component {
    constructor(props) {
        super(props);
        const { filters } = this.props;

        this.state = filters.toJS();

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleFilterTypeChange = this.handleFilterTypeChange.bind(this);
        this.handleFilterCurrencyChange = this.handleFilterCurrencyChange.bind(this);
        this.handleFilterCompareChange = this.handleFilterCompareChange.bind(this);
        this.handleFilterAccountType = this.handleFilterAccountType.bind(this);
    }

    handleFilterCompareChange(value) {
        this.setState({
            compare: value
        });

    }

    handleFilterCurrencyChange(value) {
        this.setState({
            currency: value
        });
    }

    handleFilterTypeChange(value) {

        this.setState({
            type: value
        });
    }

    handleSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        this.props.updateFilters(this.state);
        // TODO: remove following line if this is closed automatically when filter changes
        this.props.onCloseClick();
    }

    handleFilterAccountType(value) {
        this.setState({
            typeAccount: value
        });
    }

    render() {
        return (
            <div className="global-position-expenses-filter-settings">
                <div>
                    <span className="pull-right">
                        <OKButton modifier="task" inverse={true} onClick={this.props.onCloseClick}>
                            <i className="global-position-expenses-filter-settings__close-icon icon-cerrar"></i>
                        </OKButton>
                    </span>
                    <h2 className="global-position-expenses-filter-settings__header-title">
                        <FormattedText value="myGlobalPositionExpenses-expensesVisualization" format="camelCase" />
                    </h2>
                </div>
                <form>
                    <div className="global-position-expenses-filter-settings__filters-section">
                        <RadioButtonGroup
                            name="filter_type"
                            idPrefix="GP_EXPENSES_FILTER_"
                            selectedValue={this.state.type}
                            onChange={this.handleFilterTypeChange}
                        >
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-totals')} value={GP_EXPENSES_FILTER_TYPE_ALL} />
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-onlyFromAccounts')} value={GP_EXPENSES_FILTER_TYPE_ACCOUNTS} />
                            <FeatureTogglingRender notAllowedProductKey={ENABLED_CREDIT_CARD_FILTER}>
                                <RadioButton dark label={formatText('myGlobalPositionExpenses-onlyFromCards')} value={GP_EXPENSES_FILTER_TYPE_CARDS} /> 
                            </FeatureTogglingRender>
                        </RadioButtonGroup>

                        <div className="global-position-expenses-filter-settings__radio-section-title">
                            {formatText('myGlobalPositionExpenses-compareWith')}
                        </div>
                        <RadioButtonGroup
                            name="filter_compare"
                            idPrefix="GP_EXPENSES_FILTER_COMPARE_"
                            selectedValue={this.state.compare}
                            onChange={this.handleFilterCompareChange}
                        >
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-doNotCompare')} value={GP_EXPENSES_FILTER_COMPARE_NONE} />
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-previousMonth')} value={GP_EXPENSES_FILTER_COMPARE_PREVIOUS} />
                        </RadioButtonGroup>

                        <div className="global-position-expenses-filter-settings__radio-section-title">
                            {formatText('myGlobalPositionExpenses-typeAccountTitle')}
                        </div>
                        <RadioButtonGroup
                            name="filter_account_type"
                            idPrefix="GP_EXPENSES_FILTER_TYPE_ACCOUNT_"
                            selectedValue={this.state.typeAccount}
                            onChange={this.handleFilterAccountType}
                        >
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-typeAccountAll')} value={GP_EXPENSES_FILTER_TYPE_ACCOUNT_ALL}/>
                            <RadioButton dark label={formatText('myGlobalPositionExpenses-typeAccountCustom')} value={GP_EXPENSES_FILTER_TYPE_ACCOUNT_CUSTOM}/>
                        </RadioButtonGroup>

                    </div>
                    <div className="global-position-expenses-filter-settings__submit-button text-right">
                        <OKButton modifier="secondary" inverse={true} onClick={this.handleSubmit} size="small">{formatText('myGlobalPositionExpenses-apply')}</OKButton>
                    </div>
                </form>
            </div>
        );
    }
}

globalPositionExpensesFilterSettings.propTypes = {
    onCloseClick: PropTypes.func,
    updateFilters: PropTypes.func,
    filters: PropTypes.object
};

module.exports = globalPositionExpensesFilterSettings;
